import { ChangeEvent, useState } from "react";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTextArea from "../../shared/OwTextArea/OwTextArea";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import { OwFnTable } from "../../shared/OwFnTable/OwFnTable";
import IOwTableCols from "../../../models/IOwTableCols";

export interface IDeallocateSummaryRow {
    label: string;
    detail: string | number;
}

type Props = {
    closeModalFn: () => void;
    onDeallocateFn: (note: string, releasePending: boolean, releaseToAvailable: boolean) => void;
    summaryRows: IDeallocateSummaryRow[];
};

export const DeallocateInventoryModal = (props: Props) => {
    const summaryColumns: IOwTableCols[] = [
        { title: "item", valueProp: "label" },
        { title: "detail", valueProp: "detail" },
    ];

    const [note, setNote] = useState("");
    const [releasePending, setReleasePending] = useState(false);
    const [releaseToAvailable, setReleaseToAvailable] = useState(false);

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        switch (name) {
            case "deallocate_note":
                setNote(value);
                break;
            case "release_pending":
                setReleasePending(value);
                break;
            case "release_to_available":
                setReleaseToAvailable(value);
                break;
        }
    };

    return (
        <div className={"DeallocateInventoryModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle title={"deallocate_inventory"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={props.closeModalFn} />
                    </div>
                </div>
            </div>

            <div className={"mt-3"} style={{ maxHeight: 250, overflowY: "auto" }}>
                <OwFnTable columns={summaryColumns} dataSet={props.summaryRows} dataFetch={false} initialData={false} />
            </div>

            <div className={"mt-3"}>
                <OwLabel title={"note"} />
                <OwTextArea fn={handleChange} name={"deallocate_note"} value={note} />
            </div>

            {/* <div className={"mt-4"}>
                <OwCheckbox
                    name={"release_pending"}
                    fn={handleChange}
                    checked={releasePending}
                    truthyVal={true}
                    falsyVal={false}
                    label={"also_release_pending_quantities"}
                />
            </div> */}

            <div className={"mt-2"}>
                <OwCheckbox
                    name={"release_to_available"}
                    fn={handleChange}
                    checked={releaseToAvailable}
                    truthyVal={true}
                    falsyVal={false}
                    label={"release_to_general_availability"}
                />
            </div>

            <div className={"mt-4 d-flex justify-content-end"}>
                <OwButton
                    title={"confirm"}
                    fn={() => props.onDeallocateFn(note, releasePending, releaseToAvailable)}
                    className={"btn-warning"}
                />
                <OwButton title={"cancel"} fn={props.closeModalFn} className={"ms-2 btn-danger"} />
            </div>
        </div>
    );
};
